import { useContext, useState } from 'react'
import { FormContext } from '../../contexts'
import './styles.scss'
import { useElementDesign } from '../useElementDesign';
import { useMultiStep } from '../../hooks/useMultiStep';
import { InlineActionbarElementWrapper } from '../../components/InlineActionbarElementWrapper';
import { useElementStyle } from '../useElementStyle';
import InlineEditing from '../../components/InlineEditing';

export default function RadioList({ data, ...props }) {
  const [value, setValue] = useState();
  const multiStep = useMultiStep(data);
  const elementStyle = useElementStyle(data);
  const elementDesign = useElementDesign(data.id, data);

  let inputType = 'radio'
  const classPrefix = "inputTextLine"

  const roundedCornerClass = data?.roundedCorners ? 'rounded-md' : ''
  const wrapperStyle = elementStyle.borderAndWidthStyle();

  const labelStyle = elementStyle.textStyle(data?.text, 'left');
  const labelClass = elementStyle.prefixClassName(classPrefix);

  const descriptionStyle = elementStyle.textStyle(data?.labelStyle, 'left');
  const descriptionClass = elementStyle.textClassName(data?.labelStyle);

  let currentValue;
  let onChange;
  const formContext = useContext(FormContext);
  if (formContext) {
    currentValue = formContext?.inputValues[data.id]?.value;
    onChange = (e) => {
      formContext.updateValue(data.id, e.target.value)
    }
  } else {
    currentValue = value
    onChange = (e) => {
      setValue(e.target.value)
    }
  }

  return (
    <InlineActionbarElementWrapper designElement={elementDesign}>
      <fieldset className={`${elementDesign.readOnlyElementClasses()}`}>
        <InlineEditing
          initData={data}
          style={labelStyle}
          classes={`block text-sm text-gray-700 sm:mt-px sm:pt-2`}
          name='label'
          id={`label-${data.id}`}
        >
          <label style={labelStyle} className={`block text-sm text-gray-700 sm:mt-px sm:pt-2`}>
            {elementDesign.translateTerm(data.label)}
            {elementDesign.requiredFieldIndicator(data.requiredField)}
            {elementDesign.translateHelpText(data)}
          </label>
        </InlineEditing>
        <div
          className={`bg-white rounded-md -space-y-px ${elementDesign.inputErrorClasses(data.requiredField, currentValue)}`}
          onBlur={elementDesign.handleBlur}
          onChange={onChange}
        >

          {
            data.optionWithValues?.map((option, index) => {
              return (
                <label
                  key={option.id}
                  style={wrapperStyle}
                  className={`relative border p-4 flex ${roundedCornerClass} ${index === 0 && data.roundedCorners ? 'rounded-tl-md rounded-tr-md' : ''} ${index === data.optionWithValues?.length - 1 && data.roundedCorners ? 'rounded-bl-md rounded-br-md' : ''} ${elementDesign.isReadOnly() ? '' : 'cursor-pointer'}`}
                >
                  <input
                    type={inputType}
                    name={`radio-list-${data.id}`}
                    value={option.value}
                    className="h-4 w-4 mt-0.5 cursor-pointer border-gray-300 "
                    aria-labelledby="privacy-setting-0-label"
                    aria-describedby="privacy-setting-0-description"
                    checked={currentValue === option.value}
                    disabled={elementDesign.isReadOnly() || multiStep.isReadOnly}
                  />
                  <div className="ml-3 flex flex-col">
                    <span id="privacy-setting-0-label" style={labelStyle} className={`${labelClass}`}>
                      {elementDesign.translateOption(option.id, option.display, 'display')}
                    </span>
                    <span id="privacy-setting-0-description" style={descriptionStyle} className={`${descriptionClass}`}>
                      {elementDesign.translateOption(option.id, option.description, 'description')}
                    </span>
                  </div>
                </label>
              )
            })
          }

        </div>
      </fieldset>
    </InlineActionbarElementWrapper>
  )
}